import { format } from "date-fns"
import { resolveEntityStatus, } from "../../analytics-engine"
import { StatusBadge } from "../../widgets"
import type { ColumnDef } from "../../widgets"
import { DictStatus } from "@pma/types"

export function getTaskColumns(translate: (key: string) => string, statuses: DictStatus[]): ColumnDef[] {
  return [
    { header: translate("Task Name"), accessor: "taskName", sortable: true },
    { header: translate("project name"), accessor: "projectName", sortable: true },
    { header: translate("Assignee"), accessor: "assigneeName", sortable: true },
    {
      header: translate("status"),
      accessor: "statusName",
      sortable: true,
      render: (_val: any, row: any) => (
        <StatusBadge statusDisplay={{ name: row.statusName, color: row.statusColor }} />
      ),
    },
    { header: translate("Due Date"), accessor: "dueDate", sortable: true },
  ]
}

export function mapTaskToRow(task: any, statuses: DictStatus[], projectsListRaw?: any[]) {
  const display = resolveEntityStatus(task, statuses)
  const projectId = task?.project_id || task?._project?.id
  const projectName =
    task?._project?.title ||
    projectsListRaw?.find((p: any) => p.id === projectId)?.title ||
    `#${projectId || "?"}`
  const users = task?.responsible_id || []
  const assigneeName = Array.isArray(users)
    ? users.map((u: any) => (typeof u === "object" ? u?.name || "Unknown" : `User ${u}`)).join(", ")
    : "-"
  const dueDate = task?.finish_to || task?.end_date || task?.deadline || "-"
  return {
    id: task?.id,
    taskName: task?.title || task?.name || "-",
    projectId,
    projectName,
    assigneeName,
    statusName: display.name,
    statusColor: display.color,
    statusCategory: display.category,
    dueDate: dueDate !== "-" ? format(new Date(dueDate), "yyyy-MM-dd") : "-",
  }
}
